import { sestavNalezy } from './vysledovkaNalezy';

/**
 * Blok „K dořešení" — norma pravého sloupce (`standard-rozvrzeni.md` §1f):
 * nadpis sekce, pak barevná upozornění s tím, co nehraje. Stejný vzor jako
 * ve Směnách (`SmenyModul`, `Absence`, `Dochazka`), jen data jsou finanční.
 *
 * Na mobilu jede tentýž seznam nad P&L — na telefonu se Výsledovka otevírá
 * kvůli odpovědi, ne kvůli třiceti řádkům.
 */
export default function KDoreseni({ data, rezim, cardStyle, vlastniKarta = true }) {
    const nalezy = sestavNalezy(data, rezim);

    const nadpis = (
        <div className="text-[9.5px] font-bold uppercase mb-2"
            style={{ letterSpacing: '0.12em', color: 'var(--text-secondary)' }}>
            K dořešení{nalezy.length ? ` · ${nalezy.length}` : ''}
        </div>
    );

    const obsah = nalezy.length === 0
        ? <div className="text-[11.5px] leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
            Nic nehoří — plán drží a všechny doklady období jsou zpracované.
          </div>
        : nalezy.map((n, i) => (
            <div key={i} className="px-3 py-2.5 rounded-[9px]" style={{
                marginBottom: i === nalezy.length - 1 ? 0 : 7,
                background: `${n.barva}14`, border: `1px solid ${n.barva}38`,
            }}>
                <b className="block text-[11.5px] leading-snug mb-0.5" style={{ color: n.barva }}>{n.titulek}</b>
                <span className="text-[11.5px] leading-snug" style={{ color: 'var(--text-secondary)' }}>{n.detail}</span>
            </div>
        ));

    if (!vlastniKarta) {
        return <div>{nadpis}{obsah}</div>;
    }
    return (
        <div className="rounded-2xl px-4 py-3.5" style={cardStyle}>
            {nadpis}
            {obsah}
        </div>
    );
}
